<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px"
     class="bc-secondary-red-100 radius-16 pt-16 pr-24 pb-16 pl-24 w-100">
    <div class="t2-semi-bold">{{ ('i18n_af_labelRefundRejectReason#' + rejectionStage) | translate : {reason: rejectReason} }}</div>
    <div class="t4">{{ refund.comment }}</div>
</div>
